var exports = {
  "k": "xe533113f--a7d417--container",
};

module.exports = exports;
